module.exports = __webpack_public_path__ + "img/user.0c6b1bb0.svg";